import { EmailMessageSource } from '@dashboard/generated/wp/platform';

export function getEmailMessageSourceLabel(value: EmailMessageSource): string {
  switch (value) {
    case EmailMessageSource.Preview:
      return 'Preview';
    case EmailMessageSource.Api:
      return 'API';
    case EmailMessageSource.SandboxApi:
      return 'API Sandbox';
    case EmailMessageSource.Workflow:
      return 'Workflow';
    case EmailMessageSource.SandboxWorkflow:
      return 'Workflow Sandbox';
    case EmailMessageSource.Batch:
      return 'Batch';
    case EmailMessageSource.SandboxBatch:
      return 'Batch Sandbox';
    case EmailMessageSource.SandboxSmtp:
      return 'SMTP Sandbox';
    case EmailMessageSource.Smtp:
      return 'SMTP';
  }
}
